import { render, staticRenderFns } from "./EffectAiDoctor.vue?vue&type=template&id=67250067&lang=pug"
import script from "./EffectAiDoctor.vue?vue&type=script&lang=js"
export * from "./EffectAiDoctor.vue?vue&type=script&lang=js"
import style0 from "./EffectAiDoctor.vue?vue&type=style&index=0&id=67250067&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports